import { useMemo } from 'react';
import { useRouter } from '@medifind/router';

// example Link Object
// {
//         name: 'Overview',
//         id: 'overview',
//         href: `/conditions/${codingSlug}/${projectId}`,
//         paths: [{ matchPath: '/conditions/:codingSlug/:projectId' }],
//         // icon: <IconOverview color="white" />
//         title: codingName ? `${codingName}${isProcedure ? ' Procedure' : ''}` : null,
//         subtitle: isProcedure ? `Description, Latest Information and Doctors` : `Symptoms, Doctors, Treatments, Advances & More`,
//         subtitleIsH1: true,
//         shareBookmark: {
//           bookmark: { bookmarkName: codingName, codingSlug, projectId, type: 'condition' },
//           share: { type: 'page' },
//         },
//       },

export const useHeadingNavigationLinks = ({ links = [] }) => {
  const router = useRouter();
  const props = useMemo(() => {
    if (links) {
      let foundPath = null;
      let activeNavId = null;
      const link =
        links.find(({ paths, id }) => {
          foundPath = paths.find(({ matchPath }) => router.matcher(matchPath, router.location.pathname)[0]);
          if (foundPath) activeNavId = id;
          return foundPath;
        }) ||
        links.find(({ isDefault }) => isDefault) ||
        {};

      return { ...link, ...(foundPath || {}), activeNavId };
    }
    return {};
  }, [links, router.location.pathname]);

  return props;
};
